 
import { registerView } from '../viewRegistry';
import { generateAsciiArt, ensureFigletFont } from '../../utils/asciiArt';

const PHRASE = 'DOPE\nCHAIN\nWARS';

// Cache generated ASCII art for each line (ANSI Shadow font)
const _asciiCache = {};
let _asciiReady = false;

async function ensureAsciiArt() {
  if (_asciiReady) return;
  try {
    await ensureFigletFont('ANSI Shadow', '/fonts/figlet/ANSI_Shadow.flf');
    _asciiCache.block = await generateAsciiArt(PHRASE, { font: 'ANSI Shadow', width: 60 });
    _asciiReady = true;
  } catch (err) {
    console.error('Failed to load ASCII art for promo_logo:', err);
  }
}

async function renderPromoLogo(ctx, t, w, h, params = {}) {
  // Reset background every frame so glow doesn't accumulate and appear bold
  ctx.fillStyle = '#000000';
  ctx.fillRect(0, 0, w, h);
  if (!_asciiReady) {
    // kick off load then show fallback
    ensureAsciiArt();
    ctx.font = 'bold 20px monospace';
    ctx.fillStyle = '#39FF14';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Loading…', w / 2, h / 2);
    return;
  }

  // ---- Layout like widget_splash -------------------------------------------------
  const asciiLines = _asciiCache.block.split('\n');

  ctx.font = '100px monospace';
  const widestLine = asciiLines.reduce((a, b) => (a.length > b.length ? a : b));
  const widthAt100 = ctx.measureText(widestLine).width;

  const H_MARGIN_RATIO = 0.10;
  const usableW = w * (1 - H_MARGIN_RATIO);
  const candidateByWidth = (usableW / widthAt100) * 100;
  const candidateByHeight = h / asciiLines.length;
  const lineHeight = Math.max(1, Math.round(Math.min(candidateByWidth, candidateByHeight) * 0.90));
  ctx.font = `${lineHeight}px monospace`;

  const totalArtHeight = lineHeight * asciiLines.length;
  const startY = (h - totalArtHeight) / 2;

  ctx.fillStyle = '#39FF14';
  ctx.shadowColor = '#39FF14';
  ctx.shadowBlur = 10; // match icon/splash glow strength

  // Use left alignment since we compute precise startX
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';

  asciiLines.forEach((asciiLine, idx) => {
    const lineW = ctx.measureText(asciiLine).width;
    const startX = (w - lineW) / 2;
    ctx.fillText(asciiLine, startX, startY + idx * lineHeight);
  });

  ctx.shadowBlur = 0;

  // Simple bezel border
  ctx.strokeStyle = '#39FF14';
  ctx.lineWidth = 3;
  ctx.globalAlpha = 0.3; // match subtle desktop border
  ctx.strokeRect(1.5, 1.5, w - 3, h - 3);
  ctx.globalAlpha = 1.0;

  // Signal to build scripts (eg. gen-og) that the frame is complete
  if (typeof window !== 'undefined') {
    window.DCW_PROMO_READY = true;
  }
}

registerView('promo_logo', renderPromoLogo);

// ─────────────────────────────────────────────────────────────────────────────
// Ensure bezel-less profile when this view is used for screenshots.
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const path = window.location.pathname;
  // Auto-switch to bezel-less ONLY when the explicit /promo route is used.
  if (path === '/promo' && params.get('profile') !== 'full') {
    params.set('profile', 'full');
    const newUrl = `${path}?${params.toString()}`;
    window.location.replace(newUrl);
  }
}
// ───────────────────────────────────────────────────────────────────────────── 